import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { LocalStorageService } from './services/local-storage.service';
import { SocketService } from './services/socket/socket.service';
import { ConfigService } from './services/config.service';
import { TableService } from './domain/services/table.service';
import { UserService } from './domain/services/user.service';
import { ToastrService } from 'ngx-toastr';

const LANDSCAPE_TABLET_CLASS = 'landscape-tablet';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'angular-payment-table';
  private tableUpdateSubscription?: Subscription;
  private openedTableSubscription?: Subscription;
  private botUpdateSubscription?: Subscription;

  constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private socketService: SocketService,
    private configService: ConfigService,
    private tableService: TableService,
    private userService: UserService,
    private toastr: ToastrService,
    private renderer: Renderer2
  ) {
    const uuid = this.localStorageService.getItem<string>('table_uuid');
    const intent = this.localStorageService.getItem<any>('intent');
    if(uuid) {
      this.socketService.connect();
    }
    if(intent && uuid) {
      this.router.navigate([`${uuid}/payment`])
    }
  }

  ngOnInit(): void {
    this.applyLandscapeMode();

    this.tableUpdateSubscription = this.socketService.on('mesa:update').subscribe(() => {
      const uuid = this.localStorageService.getItem<string>('table_uuid');
      if (uuid) {
        this.tableService.loadTable(uuid, true);
      }
      this.applyLandscapeMode();
    });

    this.openedTableSubscription = this.tableService.$openedTable.subscribe(() => {
      this.applyLandscapeMode();
    });

    this.botUpdateSubscription = this.socketService.on<string>('bot:update').subscribe((raw) => {
      let payload: any;
      try {
        payload = typeof raw === 'string' ? JSON.parse(raw) : raw;
      } catch {
        return;
      }
      if (payload?.type !== 'logout') return;

      const storedTableId = this.localStorageService.getItem<string>('table_id');
      if (!storedTableId || String(storedTableId) !== String(payload.table)) return;

      this.userService.logout();
      this.tableService.clearSession();
      this.toastr.info('Escaneie o QR Code da mesa para acessar novamente.', 'Mesa encerrada', { timeOut: 6000 });
      this.router.navigate(['']);
    });
  }

  ngOnDestroy(): void {
    this.tableUpdateSubscription?.unsubscribe();
    this.openedTableSubscription?.unsubscribe();
    this.botUpdateSubscription?.unsubscribe();
    this.socketService.off('mesa:update');
    this.socketService.off('bot:update');
  }

  @HostListener('window:resize')
  @HostListener('window:orientationchange')
  onViewportChange(): void {
    this.applyLandscapeMode();
  }

  private applyLandscapeMode(): void {
    const enabled = this.configService.isLandscapeTabletEnabled();
    if (enabled) {
      this.renderer.addClass(document.body, LANDSCAPE_TABLET_CLASS);
    } else {
      this.renderer.removeClass(document.body, LANDSCAPE_TABLET_CLASS);
    }
  }
}
